import { vaultApi } from '@modules/vault/api';
import { useQuery } from '@tanstack/react-query';

export const useGetVaultStorage = (
  opportunityId: string | undefined
) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['vault-storage', opportunityId],
    queryFn: async () => vaultApi.getVaultStorage(opportunityId!),
    enabled: true,
    retry: false,
  });

  return {
    data,
    isLoading,
    error,
    isClientNotLoggedIn: error ? error.statusCode === 404 : false,
  };
};
